import { render, staticRenderFns } from "./sns-account.vue?vue&type=template&id=d66a9676&scoped=true&"
import script from "./sns-account.vue?vue&type=script&lang=js&"
export * from "./sns-account.vue?vue&type=script&lang=js&"
import style0 from "./sns-account.vue?vue&type=style&index=0&id=d66a9676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66a9676",
  null
  
)

export default component.exports